<template>
    <ConfirmationModal
        title="Save producer changes?"
        yes="Save changes"
        no="Cancel"
        no-color="neutral"
        additional-class-name="ProducerChangesModal"
        v-bind="$attrs"
    >
        <p class="ProducerChangesModal__paragraph" data-test-id="ProducerChangesModal__message">
            {{ message }}
        </p>
    </ConfirmationModal>
</template>

<style lang="scss">
    .ProducerChangesModal {
        &__paragraph {
            margin: 0;
        }
    }
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import ConfirmationModal from '@/components/confirmation-modal/ConfirmationModal.vue';

    /**
     * Confirms a save that changes an entity's producer list.
     *
     * The two messages describe two genuinely different outcomes. Normally a producer change only
     * takes effect at the next scheduled requirement email. But when the entity goes from having
     * no active producer to having one, the service cancels the pending reminder, issues a fresh
     * submission link and can email the producer straight away — so that case says so instead of
     * promising nothing will be sent.
     */
    @Component({
        components: {
            ConfirmationModal,
        },
    })
    export default class ProducerChangesModal extends Vue {
        @Prop({ type: Boolean, default: false })
        private firstActiveProducer!: boolean;

        private get message(): string {
            return this.firstActiveProducer
                ? 'This is the first active producer on this entity, so saving issues a fresh '
                    + 'submission link and this producer may be emailed right away. Producers added '
                    + 'after this are notified at the next email send time.'
                : 'New producers will be notified at the next email send time. Saving these '
                    + 'changes does not send any notification now.';
        }
    }
</script>
